import axios from "axios";
import idAuthHeader from "../auth-header";

const API_URL = process.env.REACT_APP_API_URL + "api/";

class UploadService {
  async uploadJobs(fileData) {
    return axios.put(API_URL + "PatientList/wci-ortho-surgery-procedure-date", fileData, {
      headers: await idAuthHeader(),
    });
  }

  async uploadMrrFile(formData) {
    return axios.post(API_URL + "uploadjob/mrr-document", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        ...(await idAuthHeader()),
      },
    });
  }
}

const uploadService = new UploadService();
export default uploadService;
